const zeroPad =(num, numZeros)=> {
    var n = Math.abs(num);
    var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
    var zeroString = Math.pow(10,zeros).toString().substr(1);
    if( num < 0 ) {
        zeroString = '-' + zeroString;
    }

    return zeroString+n;
}

const formatDate = (date, withTime)=> {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    
    switch (month) {
        case '1': month = 'Januari'; break;
        case '2': month = 'Februari'; break;
        case '3': month = 'Maret'; break;
        case '4': month = 'April'; break;
        case '5': month = 'Mei'; break;
        case '6': month = 'Juni'; break;
        case '7': month = 'Juli'; break;
        case '8': month = 'Agustus'; break;
        case '9': month = 'September'; break;
        case '10':month = 'Oktober'; break;
        case '11':month = 'November'; break;
        case '12':month = 'Desember'; break;
        default:
            break;
        }
    // if (month.length < 2) 
    //     month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    var time = '';
    if (withTime) {
        time = zeroPad(d.getHours(), 2)+':'+zeroPad(d.getMinutes(), 2);
    }

    return [day, month, year].join(' ')+' '+time;
}

function dateWithFormatParam(date, format) {
    const map = {
        'MM': ('0' + (date.getMonth() + 1)).slice(-2),
        'M': date.getMonth() + 1,
        'DD': ('0' + date.getDate()).slice(-2),
        'D': date.getDate(),
        'YYYY': date.getFullYear(),
        'YY': date.getFullYear().toString().slice(-2),
        'HH': ('0' + date.getHours()).slice(-2),
        'H': date.getHours(),
        'mm': ('0' + date.getMinutes()).slice(-2),
        'm': date.getMinutes(),
        'ss': ('0' + date.getSeconds()).slice(-2),
        's': date.getSeconds(),
    };

    return format.replace(/MM|M|DD|D|YYYY|YY|HH|H|mm|m|ss|s/gi, matched => map[matched]);
}

const formatDateLabel = (isoDateString) => {
    const date = new Date(isoDateString);
    const pad = (number) => (number < 10 ? '0' + number : number);

    // Array nama bulan
    const monthNames = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
    ];

    const formattedDate = pad(date.getDate()) + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
    const formattedTime = pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
    return formattedDate + '<br>' + formattedTime + ' WIB';

};

const formatTanggalIndonesia = (dateStr) => {
    if (!dateStr) {
        return ''; // Return an empty string or any other placeholder you prefer
    }

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) {
        return ''; // Return an empty string if the date is invalid
    }

    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1; // Bulan dimulai dari 0
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    let minutes = dateObj.getMinutes();
    let seconds = dateObj.getSeconds();

    // Nama bulan dalam Bahasa Indonesia
    const monthNames = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
    ];

    // Format waktu menjadi dua digit
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    // Format tanggal menjadi format Indonesia (dd Month yyyy / hh:mm:ss WIB)
    return `${day} ${monthNames[month - 1]} ${year} / ${hours}:${minutes}:${seconds} WIB`;
};

const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const formatDateDifferent = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffMs = now - past;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if( seconds < 60 ) return `Baru saja`;
    if(minutes < 60) return `${minutes} Menit yang lalu`;
    if(hours < 24) return `${hours} Jam yang lalu`;
    if(days < 7) return `${days} Hari yang lalu`;
    if(weeks < 4) return `${weeks} Minggu yang lalu`;
    if(months < 12) return `${months} Bulan yang lalu`;
    if(years > 0 ) return `${years} Year yang lalu`;

    return past.toLocaleString('id-ID', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    })
};

export { formatDate, dateWithFormatParam, formatDateLabel, formatTanggalIndonesia, formatDateTime, formatDateDifferent }